export default class ServerValidationError<TErrors = object, TResponse = object> extends Error {
  public readonly errors: TErrors;

  public readonly response: TResponse;

  constructor(errors: TErrors, response: TResponse) {
    super();

    this.errors = errors;
    this.response = response;
  }
}
